import React from 'react';
import './mencao.css';

// Realça @menções (ex.: @joao) num texto, deixando-as em azul.
// Não realça @ dentro de e-mails (precedido por caractere de palavra).
// Retorna um array de nós React pronto para renderizar dentro de JSX.
export default function realcarMencoes(texto) {
  if (texto == null) return texto;
  const str = String(texto);
  const regex = /(^|[^\w@])@([A-Za-z0-9._-]{2,})/g;
  const nos = [];
  let ultimo = 0;
  let m;
  let i = 0;
  while ((m = regex.exec(str)) !== null) {
    const prefixo = m[1] || '';
    const inicioMencao = m.index + prefixo.length;
    // texto antes da menção (inclui o prefixo separador)
    if (inicioMencao > ultimo) nos.push(str.slice(ultimo, inicioMencao));
    nos.push(
      <span key={`m-${i++}`} className="mencao-realce">@{m[2]}</span>
    );
    ultimo = regex.lastIndex;
  }
  if (ultimo < str.length) nos.push(str.slice(ultimo));
  return nos.length ? nos : str;
}
